import { clearAllScreenCaches } from './localCache';

// Called only after the server confirms deletion (or revokes this device with 410).
let resetting = false;
export async function finishAccountDeletion() {
    if (resetting) return;
    resetting = true;
    clearAllScreenCaches({ identityChanged: true });
    const uuid = localStorage.getItem('pill_reminder_uuid');
    try {
        if (window.ReactNativeWebView) {
            await new Promise(resolve => {
                const requestId = `delete-${Date.now()}`;
                const finish = () => {
                    clearTimeout(timer);
                    window.removeEventListener('message', handler);
                    document.removeEventListener('message', handler);
                    resolve();
                };
                const handler = event => {
                    try {
                        const msg = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                        if (msg?.type === 'ACCOUNT_DELETION_CLEANUP_RESULT' && msg.requestId === requestId) finish();
                    } catch (_) {}
                };
                const timer = setTimeout(finish, 8000);
                window.addEventListener('message', handler);
                document.addEventListener('message', handler);
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'ACCOUNT_DELETED', requestId, data: { uuid } }));
                let runtime = {};
                try { runtime = JSON.parse(localStorage.getItem('pill_reminder_app_runtime_info') || '{}') || {}; } catch (_) {}
                if (!runtime.capabilities?.accountDeletion) {
                    // Older bundles still understand these messages.
                    window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'RESET_MEDICATION_ALARMS' }));
                    window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'UPDATE_WIDGET', data: { taken: 0, total: 0, streak: 0, medications: '[]', hasMedications: false } }));
                }
            });
        }
    } finally {
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace('/');
    }
}
